



function sectionRendering() {

  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__main-wrapper", cart__html);
      $(".cart-drawer__main-wrapper").replaceWith(render__html);
      var render__html = $(".cart-drawer__top-text em", cart__html);
      $(".cart-drawer__top-text em").replaceWith(render__html);
    });
  // header 


  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__desk-cart em", cart__html);
      $(".header__desk-cart em").replaceWith(render__html);
      var render__html = $(".header__mobi-cart em", cart__html);
      $(".header__mobi-cart em").replaceWith(render__html);
    });


}



$(".product-btn-add, .main-product-btn-add").on("click", function (e) {
    e.preventDefault();
    formData = $(this).closest(".single__product-add").serialize();
    addToCart(formData)
  })

  function addToCart(formData) {
    console.log('formData:',formData);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: formData,
      success: function (data) {
        console.log(data)
         $("body").addClass("cart-open");
         sectionRendering();
      },
      error: function (err) {
        console.log('error:',err);
      },
    });
  }



  function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };
  console.log(data_line)
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {
      sectionRendering();
    }
  })
}


// remove item from cart drawer js end here



// increment quantity in cart drawer
function incrementCart(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrementCart(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRendering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}





function increment_p(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  $(".product-hero__quantity-minus").addClass("active");

}

function decrement_p(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 1 : value;
    value--;
    input.value = value;

    if (value == 1) {
      $(".product-hero__quantity-minus").removeClass("active");
    }
  }
}




  $(".product__sub-item input, .main-product__sub-item input").on("change", function () {

    if ($("#subscribe").is(":checked")) {
      $(".selling__plan-set-value").attr("name", "selling_plan");

    } else {
      $(".selling__plan-set-value").attr("name", "")
    }

  })

  $(document).on("change", ".product__selling-plan-select", function () {
  var drop_id = $(this).val();
  console.log(drop_id);
  $('.selling__plan-set-value').val(drop_id);
});